import { render, staticRenderFns } from "./TrafficFlow.vue?vue&type=template&id=c4c0776a&scoped=true"
import script from "./TrafficFlow.vue?vue&type=script&lang=js"
export * from "./TrafficFlow.vue?vue&type=script&lang=js"
import style0 from "./TrafficFlow.vue?vue&type=style&index=0&id=c4c0776a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c0776a",
  null
  
)

export default component.exports